<template>
	<div>
		<v-tooltip top>
			<template v-slot:activator="{on, attrs}">
					<span v-bind="attrs" v-on="on">
						<AsiBtn :hide-content="false"
						        :icon="icons.frameAssembly"
						        iconColor="black"
						        small
						        @click="updateDialog.open()"
						        v-bind="attrs"
						        v-on="on">
						</AsiBtn>
					</span>
			</template>
			{{ $t('frameAssembly.terms.edit') }}
		</v-tooltip>
		<FrameAssemblyUpdateDialog :frame-assembly-configuration="frameAssemblyConfiguration"
		                           :frame-assembly-configuration-group="frameAssemblyConfigurationGroup"
		                           :position-id="positionId"
		                           :cart-id="activeCart.id"
		                           :open="updateDialog.isOpen" @cancel="updateDialog.close()" @save="save(); updateDialog.close();" />
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from "vue-property-decorator";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import FrameAssemblyUpdateDialog from "@/components/frame-assembly/FrameAssemblyUpdateDialog.vue";
	import DialogHandler from "@/components/common/DialogHandler";
	import Icon from "@/plugins/icons";
	import {
		IFrameAssemblyConfiguration,
		IFrameAssemblyConfigurationGroup
	} from "@/models/frame-assembly/FrameAssemblyModels";
	import {ICartShopListEntry} from "@/models/cart/CartShopModels";

	@Component({
		components: {FrameAssemblyUpdateDialog, AsiBtn}
	})
	export default class FrameAssemblyButton extends Vue {

		@Prop({type: Object, required: true})
		public frameAssemblyConfiguration!: IFrameAssemblyConfiguration;

		@Prop({type: Object, required: true})
		public frameAssemblyConfigurationGroup!: IFrameAssemblyConfigurationGroup;

		@Prop({type: String, required: true})
		public positionId!: string;

		private icons = Icon;

		private updateDialog: DialogHandler = new DialogHandler();

		private get activeCart() {
			return this.$store.getters['cart/activeCart'] as ICartShopListEntry | null;
		}

		@Emit('save')
		public save(): void {
			return;
		}
	}
</script>

<style lang="scss" scoped>

</style>
